import { Component, OnInit } from '@angular/core';
import { GuestKpiSnapshot } from './marketing-dashboard.models';
import { MarketingDashboardService } from './marketing-dashboard.service';

@Component({
	selector: 'app-marketing-dashboard',
	templateUrl: './marketing-dashboard.component.html',
	styleUrls: ['./marketing-dashboard.component.scss'],
	standalone: false
})
export class MarketingDashboardComponent implements OnInit {

	guestSnapshot: GuestKpiSnapshot | null = null;

	constructor(private marketingDashboardService: MarketingDashboardService) { }

	ngOnInit(): void {
		this.loadGuestSnapshot();
	}

	private loadGuestSnapshot(): void {
		this.marketingDashboardService.getGuestSnapshot().subscribe(
			snapshot => {
				this.guestSnapshot = snapshot;
			},
			err => {
				console.error('MarketingDashboard: failed to load guest snapshot', err);
			}
		);
	}
}
